import { useTranslation } from "react-i18next";
import { useDaycareHotelAccess } from "@/hooks/useDaycareHotelAccess";
import { usePermissionsMap } from "@/hooks/usePermissionsMap";
import OvernightSection from "../accommodations/OvernightSection";
import StayScheduleDefaultsSection from "../accommodations/StayScheduleDefaultsSection";
import DailyRatesSection from "./DailyRatesSection";
import DaycareHotelSyncToggle from "./DaycareHotelSyncToggle";
import StayPackagesSection from "./StayPackagesSection";
import StayPlansSection from "./StayPlansSection";

export default function SettingsTab() {
  const { t } = useTranslation("daycareHotel");
  const { hasDaycare, hasHotel, isLoading } = useDaycareHotelAccess();
  const { data: permissions } = usePermissionsMap();

  if (isLoading) return <div className="py-10 text-center text-muted-foreground">{t("common.loading")}</div>;
  if (!hasDaycare && !hasHotel) return <div className="py-10 text-center text-muted-foreground">{t("settings.empty")}</div>;

  const canEditSync = permissions?.daycare?.update === true || permissions?.hotel?.update === true;

  return <div className="flex flex-col gap-8 py-2">
    <DaycareHotelSyncToggle canEdit={canEditSync} />
    <StayScheduleDefaultsSection
      hasDaycare={hasDaycare}
      hasHotel={hasHotel}
      canEditDaycare={permissions?.daycare?.update === true}
      canEditHotel={permissions?.hotel?.update === true}
    />
    <DailyRatesSection
      hasDaycare={hasDaycare}
      hasHotel={hasHotel}
      canEditDaycare={permissions?.daycare?.update === true}
      canEditHotel={permissions?.hotel?.update === true}
    />
    {hasDaycare ? <OvernightSection canEdit={permissions?.daycare?.update === true} /> : null}
    {hasDaycare ? (
      <StayPlansSection
        canCreate={permissions?.daycare?.create === true}
        canEdit={permissions?.daycare?.update === true}
        canDelete={permissions?.daycare?.delete === true}
      />
    ) : null}
    <StayPackagesSection
      hasDaycare={hasDaycare}
      hasHotel={hasHotel}
      canCreateDaycare={permissions?.daycare?.create === true}
      canCreateHotel={permissions?.hotel?.create === true}
      canEditDaycare={permissions?.daycare?.update === true}
      canEditHotel={permissions?.hotel?.update === true}
      canDeleteDaycare={permissions?.daycare?.delete === true}
      canDeleteHotel={permissions?.hotel?.delete === true}
    />
  </div>;
}
